"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require("autobind-decorator");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reactApollo = require("react-apollo");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

exports.default = function (Comp) {
	var _class, _desc, _value, _class2;

	return (0, _reactApollo.withApollo)(_class = (_class2 = function (_React$Component) {
		(0, _inherits3.default)(WithApolloQueriesInFlight, _React$Component);

		function WithApolloQueriesInFlight(props) {
			(0, _classCallCheck3.default)(this, WithApolloQueriesInFlight);

			var _this = (0, _possibleConstructorReturn3.default)(this, (WithApolloQueriesInFlight.__proto__ || Object.getPrototypeOf(WithApolloQueriesInFlight)).call(this, props));

			_this.unsubscribe = props.client.store.subscribe(_this.onClientStoreUpdate);

			_this.state = {
				queryStatuses: {},
				mutationsLoading: {
					false: 0
				}
			};
			return _this;
		}

		(0, _createClass3.default)(WithApolloQueriesInFlight, [{
			key: "onClientStoreUpdate",
			value: function onClientStoreUpdate() {
				var _props$client$store$g = this.props.client.store.getState().apollo,
				    mutations = _props$client$store$g.mutations,
				    queries = _props$client$store$g.queries;


				var queryStatuses = _ramda2.default.pipe(_ramda2.default.values, _ramda2.default.pluck("networkStatus"), _ramda2.default.countBy(_ramda2.default.identity))(queries);

				var mutationsLoading = _ramda2.default.pipe(_ramda2.default.values, _ramda2.default.pluck("loading"), _ramda2.default.countBy(_ramda2.default.identity))(mutations);

				this.setState({
					queryStatuses: queryStatuses,
					mutationsLoading: mutationsLoading
				});
			}
		}, {
			key: "render",
			value: function render() {
				return _react2.default.createElement(Comp, (0, _extends3.default)({}, _ramda2.default.omit(["client"])(this.props), this.state));
			}
		}, {
			key: "componentWillUnmount",
			value: function componentWillUnmount() {
				if (this.unsubscribe) {
					this.unsubscribe();
				}
			}
		}]);
		return WithApolloQueriesInFlight;
	}(_react2.default.Component), (_applyDecoratedDescriptor(_class2.prototype, "onClientStoreUpdate", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class2.prototype, "onClientStoreUpdate"), _class2.prototype)), _class2)) || _class;
};

//# sourceMappingURL=withApolloQueriesInFlight.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/enhancers/withApolloQueriesInFlight.js
// module id = 384
// module chunks = 0